import React from 'react';

import { Input } from '@/components/Input';

export const TimePicker = (props) => <Input type="time" {...props} />;
